import React, { useState } from 'react';
import ReproductionResultDropdown from './ReproductionResultDropdown.js';
import { Fetch } from '../../utils/Utils.js';

// A dedicated component (rather than a plain function returning JSX inline
// in the column def) so it can hold its own per-row error state — matches
// ListHerdAnimals.js's TagCell, the existing precedent for "an inline-edit
// table cell that can fail needs its own component to show that." Unlike
// TagCell's hardcoded tooltip text, this shows the real server message
// (e.g. "only female animals can have a reproduction outcome recorded") —
// Fetch's error callback started carrying that text once dropped instead of
// nothing, so there's something worth showing.
export const ReproductionResultCell = ({ row, onChanged }) => {
  const [error, setError] = useState('');
  return (
    <div className="reproduction-result-cell">
      <ReproductionResultDropdown
        result={row.outcome}
        onChange={(value) => {
          setError('');
          Fetch(
            "api/reproduction/result", "PATCH",
            JSON.stringify({ _id: row._id, outcome: value.currentTarget.value }),
            onChanged,
            (message) => setError(message || 'error updating reproduction result'),
          );
        }}
      />
      {error && <span className="reproduction-result-error" title={error}>!</span>}
    </div>
  );
};

export default ReproductionResultCell;
